interface GetGraphqlOperationUrlArgs {
  graphqlUrl: string;
  operationName?: string;
}

// Load balancer access logs keep the URL but not the body, so the operation
// name has to be in the URL for latency and size to be traced to a screen.
export const getGraphqlOperationUrl = ({
  graphqlUrl,
  operationName,
}: GetGraphqlOperationUrlArgs): string => {
  if (!operationName) {
    return graphqlUrl;
  }

  return `${graphqlUrl}?op=${encodeURIComponent(operationName)}`;
};
